module.exports = __webpack_public_path__ + "static/ari-luks-fresh-ce954951590f69bc2de6918c504e5b69.png";